import React from 'react';
import { Dialog, DialogTitle, DialogContent, Button, Typography, Stack, Box } from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import TranslateIcon from '@mui/icons-material/Translate';
import SwiftLogo from '../../assets/images/navlogo.svg';
import PteDashboardBackground from '../../assets/images/pte-dashboard-modal-background.png';

/**
 * Simple preference dialog that lets the user select between PTE and IELTS.
 * Props:
 *   open    : boolean – controls visibility
 *   onSelect: function(examType) – called with 'pte' or 'ielts'
 */
const ExamPreferenceModal = ({ open, onSelect }) => {
  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      maxWidth="xs"
      fullWidth
      BackdropProps={{
        'data-testid': 'exam-preference-backdrop',
        sx: {
          backgroundColor: 'rgba(255, 255, 255, 0.28)',
          backgroundImage: `url(${PteDashboardBackground})`,
          backgroundPosition: 'center top',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          filter: 'blur(7px)',
          transform: 'scale(1.02)',
        },
      }}
      PaperProps={{ sx: { borderRadius: 3, overflow: 'hidden' } }}
    >
      <Box sx={{ px: { xs: 3, sm: 4 }, pt: 3, pb: 2.5, backgroundColor: '#f4f7fb', borderBottom: '1px solid #e5eaf0' }}>
        <Box component="img" src={SwiftLogo} alt="SwiftUni" sx={{ display: 'block', width: 145, maxWidth: '55%', height: 'auto', mx: 'auto', mb: 2 }} />
        <Stack direction="row" justifyContent="center" alignItems="center" spacing={1.5}>
          <Box sx={{ display: 'grid', placeItems: 'center', width: 48, height: 48, borderRadius: 2, backgroundColor: '#e8f1ff', color: '#1976d2' }}>
            <SchoolIcon />
          </Box>
          <Typography component="span" sx={{ color: '#9aa7b5', fontWeight: 700 }}>+</Typography>
          <Box sx={{ display: 'grid', placeItems: 'center', width: 48, height: 48, borderRadius: 2, backgroundColor: '#f4eafa', color: '#8e24aa' }}>
            <TranslateIcon />
          </Box>
        </Stack>
        <DialogTitle sx={{ p: 0, mt: 2, textAlign: 'center', fontSize: '1.25rem' }}>Choose your exam</DialogTitle>
        <Typography variant="body2" sx={{ mt: 0.75, textAlign: 'center', color: 'text.secondary' }}>
          Choose your preparation path
        </Typography>
      </Box>

      <Box sx={{ p: { xs: 2.5, sm: 3 } }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
          <Button
            variant="outlined"
            fullWidth
            onClick={() => onSelect('pte')}
            sx={{ flex: 1, minHeight: 82, flexDirection: 'column', gap: 0.5, borderColor: '#90caf9', color: '#1565c0', backgroundColor: '#f7fbff', textTransform: 'none', '&:hover': { borderColor: '#1976d2', backgroundColor: '#edf5ff' } }}
          >
            <SchoolIcon />
            <Typography component="span" sx={{ fontWeight: 700 }}>PTE</Typography>
          </Button>
          <Button
            variant="outlined"
            fullWidth
            onClick={() => onSelect('ielts')}
            sx={{ flex: 1, minHeight: 82, flexDirection: 'column', gap: 0.5, borderColor: '#ce93d8', color: '#7b1fa2', backgroundColor: '#fcf7fd', textTransform: 'none', '&:hover': { borderColor: '#8e24aa', backgroundColor: '#f8effa' } }}
          >
            <TranslateIcon />
            <Typography component="span" sx={{ fontWeight: 700 }}>IELTS</Typography>
          </Button>
        </Stack>
      </Box>
    </Dialog>
  );
};

export default ExamPreferenceModal;
